// extracted by mini-css-extract-plugin
export default {"table":"Slider_table__-LhXK","customRangePayout":"Slider_customRangePayout__oJ+T2"};